import { initials } from '../utils/format.js';

// Avatar de usuário (iniciais) — usado em qualquer lugar que precise identificar
// a conta logada (home, stepper do fluxo de compra, menu de conta) para manter
// o mesmo visual em todos eles.
export default function Avatar({ user, size = 38, fontSize, onClick, ariaLabel = 'Minha conta', style }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag onClick={onClick} aria-label={onClick ? ariaLabel : undefined} style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: fontSize ?? Math.round(size * 0.34),
      color: 'var(--white)', background: 'var(--brand-primary)',
      ...style,
    }}>
      {initials(user?.first_name, user?.last_name)}
    </Tag>
  );
}
